<template>
	<div class="welcomePage">
		<filter-panel :data="groups" @search="filterChange"></filter-panel>
		<data-list
			:data="data"
			:columns="column"
			:btnList="btnList"
			page="page"
			:page-size="page.pageSize"
			:loading="loading"
			@page-size-changed="pageSizeChanged"
			@page-changed="pageChanged"
		></data-list>

		<addWelcomePageForm
			ref="addWelcomePageForm"
			dialogWidth="650px"
			:title="addWelcomePageFormTitle"
		></addWelcomePageForm>
	</div>
</template>

<script>
import filterPanel from '@/components/iglobalwin/filterPanelNew/filterPanel.vue';
import addWelcomePageForm from './addWelcomePageForm.vue';
import listPageCreate from '@/mixins/listPageCreate';
import api from '@/backend/apiConfig/apiConfig';
import welcomePageSer from '@/backend/services/welcomePage/welcomePageSer.js';

const list = listPageCreate({
	searchConfig: {
		api: api.welcomePage.welcomeList,
		method: 'POST',
	},
});

export default {
	name: 'welcomePage',
	props: [],
	components: {
		filterPanel,
		addWelcomePageForm,
	},
	mixins: [list],
	data() {
		let self = this;
		return {
			groups: {
				others: [
					{
						tagName: 'sky-input',
						placeholder: '标题',
						label: '标题',
						prop: 'title',
						value: '',
					},
				],
				multiples: [
					{
						defaultText: '系统端',
						placeholder: '系统端',
						label: '系统端',
						options: [
							{ label: '全球赢Web端', value: '1' },
							{ label: '全球赢APP端', value: '2' },
						],
						prop: 'systemType',
						value: '',
					},
				],
			},
			btnList: [
				{
					name: '新增',
					position: 'right',
					attribute: {
						type: 'primary',
						size: 'medium',
					},
					async btnClick() {
						self.addWelcomePageFormTitle = '增加欢迎页';
						let { cancel } = await self.$refs.addWelcomePageForm.show();
						if (!cancel) {
							self.$message({
								message: '新增成功',
								type: 'success',
							});
							self.query();
						}
					},
				},
			],
			column: [
				{
					label: '标题',
					bind: 'title',
				},
				{
					label: '发布系统端',
					bind: row => {
						let { systemTypeList } = row;
						if (!systemTypeList) return '--';
						let list = systemTypeList.map(item => {
							if (item === '1') return '全球赢Web端';
							else return '全球赢APP端';
						});
						return list.join('，');
					}, //(1:web端;2:APP端;)
				},
				{
					label: '是否显示',
					type: 'switchBtn',
					bind: 'showFlag',
					activeValue: 1,
					inactiveValue: 0,
					disabled: row => {
						let { defaultFlag, showFlag, systemTypeList } = row;
						if (!systemTypeList) return false;
						return defaultFlag === 1 || showFlag === 1;
					},
					toggle(val, row) {
						self.switchBtnChange(val, row);
					},
				},
				{
					label: '操作',
					type: 'iconbutton',
					align: 'center',
					width: 150,
					iconlist: [
						{
							id: 1,
							name: 'bianji',
							style: {
								color: '#3DA1FF',
							},
							message: '编辑',
							callback(row) {
								self.addWelcomePageFormTitle = '编辑欢迎页';
								self.edit(row);
							},
						},
					],
				},
			],
			partList: [],
			addWelcomePageFormTitle: '增加欢迎页',
		};
	},
	computed: {},
	watch: {},
	mounted() {
		this.init();
	},
	methods: {
		// 初始化
		init() {
			this.query();
		},
		// 获取详情打开编辑弹窗
		async edit(row) {
			let { id } = row;
			let res = await welcomePageSer.welcomeDetail({
				id,
			});
			if (res.data) {
				let { cancel } = await this.$refs.addWelcomePageForm.show(res.data);
				if (!cancel) {
					this.$message({
						message: '修改成功',
						type: 'success',
					});
					this.query();
				}
			}
		},
		// 是否显示按钮点击
		async switchBtnChange(showFlag, row) {
			let { id } = row;
			let res = await welcomePageSer.welcomeShowswitch({
				id,
				showFlag,
			});
			if (res.data) this.query();
		},
	},
};
</script>

<style lang="scss" scoped>
.welcomePage {
}
</style>
